export default __webpack_public_path__ + "static/media/4.47e94f7f.jpg";